/**
 * English translations for the Four Key Palace analysis
 */

const fourKeyPalace = {
  fourKeyPalace: "Four Transformations Analysis",
  // Four Transformations content
  fourKeyPalaceContent: {
    notFound: "Not found in chart",
    // Transformation types
    "化禄": "Fortune",
    "化权": "Power",
    "化科": "Status",
    "化忌": "Obstacle",
    // Default information
    defaultTitle: "{0} in {1}",
    defaultDesc: "This transformation is in the {0} palace.",
    defaultQuote: "Information not available for this palace.",
    
    // Restructured palace information
    命宫: {
      name: "Destiny Palace",
      keyword: "🧠 Destiny Palace (Appearance/Character/Star Enhancement)",
      meaning: "Self-state, mindset, personality, dominance",
      HuaLu: {
        title: "☀️ Prosperity in Destiny Palace",
        description: "You begin to possess a strong personal aura and attraction, winning attention without saying much. You'll clearly feel: people look at you differently now, you're the protagonist wherever you stand. Destiny is raising your light, the key is whether you dare to catch this spotlight.",
        quote: "The moment you stand out, destiny also stands by your side."
      },
      HuaQuan: {
        title: "⚡ Power in Destiny Palace",
        description: "You now increasingly want to 'control your own life'. In the past others helped you decide, you were afraid of saying wrong things, now you'll start to actively set rules. This feeling of wanting to win, wanting to control, wanting to decide, is not willfulness, it's awakening.",
        quote: "You're not a control freak, you're finally starting to 'take charge'."
      },
      HuaKe: {
        title: "⚡ Achievement in Destiny Palace",
        description: "Your wisdom, speech, and logical thinking will become your most shining label. Others will look at you with new eyes because of your expression, temperament, and knowledge. This is not pretending to have substance, this is you deserving to be understood.",
        quote: "You naturally have presence, but now you're starting to see it."
      },
      HuaJi: {
        title: "🌀 Obstacle in Destiny Palace",
        description: "You tend to feel 'Am I not good enough somewhere' 'Should I work harder'. These voices are not destiny negating you, but cleaning your habit of 'pleasing the world'.",
        quote: "You're not broken, you've just been living for others too long."
      }
    },
    兄弟: {
      name: "Siblings Palace",
      keyword: "👬 Siblings Palace (Brothers & Sisters/Resource Loss)",
      meaning: "Partnership relationships, friend circles, brotherhood, peer influence",
      HuaLu: {
        title: "☀️ Prosperity in Siblings Palace",
        description: "You begin to establish a high-quality network system: siblings, friend circles, and partners can all bring wealth. Those who strive together, fly together; benefactors will approach you through friends.",
        quote: "Your circle determines how much money you will make in the future."
      },
      HuaQuan: {
        title: "⚡ Power in Siblings Palace",
        description: "You'll begin to have a 'desire for control' over relationships: wanting to decide who should stay, who shouldn't be close friends. This impulse to organize your friend circle and team relationships isn't coldness, it's a higher-dimensional filtering ability.",
        quote: "You haven't grown cold, you're selecting the right people to win with."
      },
      HuaKe: {
        title: "💫 Achievement in Siblings Palace",
        description: "You begin to establish professional influence from your friend circle/partnerships. Your words, strategies you propose, advice you give, will be viewed as those of a thought leader.",
        quote: "You're not just making friends, you're forming an alliance circle of influence."
      },
      HuaJi: {
        title: "🌀 Obstacle in Siblings Palace",
        description: "You will experience some interpersonal fluctuations: disconnections, conflicts, falling out or loss. This is destiny helping you 'cut ties', not sabotaging you.",
        quote: "It's not friends leaving you, but your energy frequency has advanced."
      }
    },
    夫妻: {
      name: "Marriage Palace",
      keyword: "❤️ Marriage Palace (Relationship Status/Pre-marriage Relationship)",
      meaning: "Love relationship, partner, long-term pairing interactions",
      HuaLu: {
        title: "☀️ Prosperity in Marriage Palace",
        description: "You begin to have the ability to attract 'wealth-bringing relationships', and your romantic energy will rise in these years. But you need to figure out what kind of relationship you want first, otherwise it's easy to have many suitors but a confused heart.",
        quote: "Your relationship isn't just for companionship, it's to expand your life's strategy."
      },
      HuaQuan: {
        title: "⚡ Power in Marriage Palace",
        description: "You will desire to lead the relationship, control the pace, want a voice in the partnership. What you want isn't just sweetness, but co-building and resonance.",
        quote: "You're not looking for someone to accompany you, you're choosing a partner to conquer the world with."
      },
      HuaKe: {
        title: "💫 Achievement in Marriage Palace",
        description: "Your romantic energy begins to shine, and attention-grabbing glances start appearing in your social circle. You will attract partners with 'spiritual matching' and 'value resonance'.",
        quote: "You don't lack love, you just lack a relationship worth upgrading for."
      },
      HuaJi: {
        title: "🌀 Obstacle in Marriage Palace",
        description: "You may experience relationship friction, trust tests, dragging issues or cyclical predicaments. It's not that you loved the wrong person, but destiny is teaching you how to 'learn to love yourself first'.",
        quote: "Relationships haven't ruined you, you're finally learning what true love is."
      }
    },
    子女: {
      name: "Children Palace",
      keyword: "👶 Children Palace (Fertility/Sex Life/Creative Energy/Team/New Projects)",
      meaning: "Students, children, teams, creative products",
      HuaLu: {
        title: "☀️ Prosperity in Children Palace",
        description: "You begin to have the ability to nurture powerful creations/teams/new projects. These years are suitable for having children, creating works, starting side businesses, with energy productivity doubled!",
        quote: "You are a creator, every decision will generate value."
      },
      HuaQuan: {
        title: "⚡ Power in Children Palace",
        description: "You'll want to strongly push a plan, educate children, train teams, build brands. This isn't an explosion of control, it's a sign of your mature energy.",
        quote: "You're not managing things, you're establishing your creative universe."
      },
      HuaKe: {
        title: "💫 Achievement in Children Palace",
        description: "You begin to want to express creativity in 'more beautiful ways', whether in writing, parenting, design, or speaking. What you teach, others will remember; what you create, will be admired.",
        quote: "You're not an ordinary parent/creator, you're a transmitter of talent."
      },
      HuaJi: {
        title: "🌀 Obstacle in Children Palace",
        description: "You may feel stuck, anxious, or sacrificial about children, sexuality, creativity. This isn't an ability issue, it's that you've given too much without setting boundaries.",
        quote: "Stop overgiving, your energy deserves to be protected."
      }
    },
    财帛: {
      name: "Wealth Palace",
      keyword: "💰 Wealth Palace (Money, Cash Flow, Investment, Assets, Long-term Plans)",
      meaning: "Income source, financial system, money flow structure",
      HuaLu: {
        title: "☀️ Prosperity in Wealth Palace",
        description: "You now begin to have the ability to master your own money flow. These years you'll easily have extra income, clients, additional revenues, and even your investment vision starts to become 'sharp'. You'll find: as long as you dare to set prices, push yourself, play with resources, money will start moving. More importantly, your 'long-term asset system' is beginning to build, not just quick money, but the kind that accumulates.",
        quote: "You're not here to work for money, you're here to build assets."
      },
      HuaQuan: {
        title: "⚡ Power in Wealth Palace",
        description: "You begin to desire control over money, rather than waiting for money to dictate your pace. During this time, you'll want to invest, learn financial intelligence, create passive income, open new accounts, play with new business models. These impulses aren't greed, it's your destiny chart telling you: it's time for you to be the boss of money. You'll change from 'afraid to spend' to 'daring to move money'. This is a sign of financial control returning to you.",
        quote: "You're not just an earner, you're the operator of money flow."
      },
      HuaKe: {
        title: "💫 Achievement in Wealth Palace",
        description: "Your expertise, personal charm, service value will directly be 'paid back' during this time. People used to just praise you, now they'll open their wallets for you. You begin to know that 'pricing' is respecting yourself, 'quoting' is a declaration of the soul. You're building your own high-asset value label, the clearer it is, the more valuable it becomes.",
        quote: "Your worth is determined from the moment you speak up."
      },
      HuaJi: {
        title: "🌀 Obstacle in Wealth Palace",
        description: "During this time, you may feel 'earn and spend', 'money comes but doesn't stay', 'never seems enough no matter how you look at it'. This isn't about your inability to make money, it's that you haven't set good financial boundaries and strategies. Stop being afraid to look at numbers, true abundance begins with facing your account books.",
        quote: "It's not that money isn't coming in, it's that you're not ready to catch it."
      }
    },
    疾厄: {
      name: "Health Palace",
      keyword: "🩺 Health Palace (Physical Health, Accidents, Surgery, Emotional Resilience)",
      meaning: "Health condition, psychological emotion, stress management",
      HuaLu: {
        title: "☀️ Prosperity in Health Palace",
        description: "You begin to restore energy, strengthen your constitution, as long as you pay a little attention to taking care of yourself, your body will respond to you. This is the most suitable stage for you to nurture your body, adjust frequency, and activate body memory.",
        quote: "Your body hurts because it knows you deserve to be treated well."
      },
      HuaQuan: {
        title: "⚡ Power in Health Palace",
        description: "You begin to want control over your physical state, psychological pressure, and life rhythm, wanting change. This is your destiny chart calling you to 'take back control of your own body', stop handing it over to doctors or fate.",
        quote: "You are your own strongest doctor, the strongest medicine is in your hands."
      },
      HuaKe: {
        title: "💫 Achievement in Health Palace",
        description: "You begin to have new understanding about health, possibly researching nutrition, exercise, energy medicine. The body is your best practice field for learning to perceive and master life rhythm.",
        quote: "The body is not an obstacle, it's the guide to soul awakening."
      },
      HuaJi: {
        title: "🌀 Obstacle in Health Palace",
        description: "In these years, you're prone to minor illnesses, emotional explosions, physical sensitivity or exhaustion. Don't just look at the symptoms, look back at what emotions you've suppressed, what rhythms you've sacrificed.",
        quote: "You're not sick, you've just been ignored by yourself for too long."
      }
    },
    迁移: {
      name: "Travel Palace",
      keyword: "✈️ Travel Palace (Travel, External Environment, Foreign Destiny)",
      meaning: "External development, foreign opportunities, social occasions",
      HuaLu: {
        title: "☀️ Prosperity in Travel Palace",
        description: "You begin to have benefactors in distant places, good fortune in other locations, opportunities waiting for you outside your circle. As long as you're willing to go out, destiny will give you different scenery and breakthroughs.",
        quote: "Every step you take is space exchanged for energy towards an explosion."
      },
      HuaQuan: {
        title: "⚡ Power in Travel Palace",
        description: "You begin to think about changing jobs, immigration, moving, expansion... Don't suppress it, this isn't rash impulse, it's energy being awakened. The more you're in another place, the more you feel it's your home field. Your power is gained by going out, not by staying in place.",
        quote: "Your original territory can't match the ambition of your new version."
      },
      HuaKe: {
        title: "💫 Achievement in Travel Palace",
        description: "When you go out, you'll meet benefactors, learning opportunities, inspiration, and even 'guiding strangers' in your destiny. These encounters aren't coincidence, it's your destiny chart activating the 'mobile law of attraction'.",
        quote: "Every time you go out, it's a meeting between your soul and the universe."
      },
      HuaJi: {
        title: "🌀 Obstacle in Travel Palace",
        description: "You may experience 'still stuck after changing places', 'physically present but mentally unstable' issues. This isn't bad luck, it's that you haven't properly handled [letting go of things in your original place].",
        quote: "True transformation isn't changing addresses, it's changing frequencies."
      }
    },
    交友: {
      name: "Friends Palace",
      keyword: "🌐 Friends Palace (Social Circles/Benefactors & Troublemakers/Cooperation Luck)",
      meaning: "Social circle, relationship depth, group dynamic",
      HuaLu: {
        title: "☀️ Prosperity in Friends Palace",
        description: "You begin to attract collaborators and connections that add value to your career, and the external world begins to respond to your efforts. Your benefactors are often hidden in circles outside your own, among people at higher levels.",
        quote: "The circles you expand into are the ore veins of your future resources."
      },
      HuaQuan: {
        title: "⚡ Power in Friends Palace",
        description: "You want to grasp the right to speak, establish a dominant position in external relationships. This is your stage of evolving from a social participant to a resource integrator.",
        quote: "You're not expanding your list, you're building your own influence network."
      },
      HuaKe: {
        title: "💫 Achievement in Friends Palace",
        description: "Your expertise, concepts, expressions begin to be amplified and recognized in external circles. Your personal brand is no longer just 'someone's friend', but a 'brand worth collaborating with'.",
        quote: "The way you present yourself is how others remember you."
      },
      HuaJi: {
        title: "🌀 Obstacle in Friends Palace",
        description: "You may feel ostracized, experience failed collaborations, misunderstandings or even encounter villains. These aren't social punishments, but the universe helping you 'eliminate cooperation frequencies that don't match'.",
        quote: "The breakdown of interpersonal relationships is the necessary path before your level upgrade."
      }
    },
    官禄: {
      name: "Career Palace",
      keyword: "🏢 Career Palace (Career Achievement, Stability, Social Status, Promotion, Team, Systematization)",
      meaning: "Career direction, workplace performance, sense of work achievement",
      HuaLu: {
        title: "☀️ Prosperity in Career Palace",
        description: "You begin to become the person who 'gets noticed'. Whether in workplace, entrepreneurship or community, as long as you're willing to speak up and act, your performance will be seen and affirmed. These years you'll clearly feel: people begin to 'find you to do things' rather than you 'finding things to do'. Bosses value you, clients trust you, you might even get promoted, headhunted, or given important roles.",
        quote: "You're not destined to be assigned work, but destined to shine."
      },
      HuaQuan: {
        title: "⚡ Power in Career Palace",
        description: "You begin to want to lead projects, operate processes, even lead people yourself. This impulse to 'want position, want to break the status quo, want promotion' isn't ambition, it's destiny approving your actions. You will no longer just execute, but become someone who sets rules, leads processes, manages performance. Systems, institutions, human resource structures will become your weapons for advancement, not burdens.",
        quote: "Your personal brand shouldn't be an employee, but a CEO who can lead an entire winning team."
      },
      HuaKe: {
        title: "💫 Achievement in Career Palace",
        description: "Your career professionalism, levels, brand sense will all be amplified. People will begin to say 'they're very capable', 'they're very stable', 'they have vision', and these are energy labels you've set for yourself. No matter how you present your career, you'll begin to 'be remembered, be spoken about'.",
        quote: "The professional aura you establish now determines how high you can stand in the next few years."
      },
      HuaJi: {
        title: "🌀 Obstacle in Career Palace",
        description: "You may feel 'very tired of doing', 'effort without results', 'being watched by bosses, pressured by clients, projects exploding'. It's not that your career is bad, but that you're still using old energy methods to play a new energy game. At this point, it's not about working harder, but restructuring your entire career system.",
        quote: "You're not stuck, destiny just won't let you continue using a low version on the battlefield."
      }
    },
    田宅: {
      name: "Property Palace",
      keyword: "🏡 Property Palace (Family, Real Estate, Spatial Energy)",
      meaning: "Real estate properties, living environment, inner sense of security",
      HuaLu: {
        title: "☀️ Prosperity in Property Palace",
        description: "You begin to have the ability to create your own energy field and dwelling, whether buying a house, moving, or arranging space, it will drive overall energy flow. These years your 'family stability' will determine the direction of your overall fortune.",
        quote: "When home is stable, your wealth has a place to land."
      },
      HuaQuan: {
        title: "⚡ Power in Property Palace",
        description: "You increasingly want to 'control your own territory': maybe moving, living alone, buying a house, changing offices... It doesn't mean you love to fuss, but your destiny chart grants you a right: you have the right to choose your base.",
        quote: "You shouldn't adapt to the environment, you should create the environment."
      },
      HuaKe: {
        title: "💫 Achievement in Property Palace",
        description: "You begin to value spatial aesthetics, spiritual belonging, environmental levels. This isn't material desire, it's your soul saying: 'I want to live worthy of myself.'",
        quote: "Every inch of space you create hides your energy settings."
      },
      HuaJi: {
        title: "🌀 Obstacle in Property Palace",
        description: "In these years, you're prone to feeling imbalanced about 'home': insecurity, arguments, moving around, loss of control... Don't think it's an environmental problem, it's that your energy field hasn't stabilized.",
        quote: "When space is in chaos, it's the soul reminding you: the root system needs to be organized."
      }
    },
    福德: {
      name: "Happiness Palace",
      keyword: "💫 Happiness Palace (Mental State, Spiritual Thinking, Stress Preferences)",
      meaning: "Mental richness, ability to enjoy, soul nourishment",
      HuaLu: {
        title: "☀️ Prosperity in Happiness Palace",
        description: "You begin to have the ability to truly enjoy life, not just survive. You'll find your desire to 'live meaningfully' grows stronger, no longer willing to live a compromised life. These years your attraction will also significantly increase, because you become inherently abundant and radiant.",
        quote: "The more internally wealthy you are, the more externally deserving you become."
      },
      HuaQuan: {
        title: "⚡ Power in Happiness Palace",
        description: "You begin to desire control over your emotions, spirit and mental state. You're no longer content to be someone pushed around by emotions, but want to learn to master your energy flow. This is the stage of your spiritual power activation: the more you can lead internally, the more destiny listens to you.",
        quote: "True strength isn't being outwardly tough, it's being inwardly stable."
      },
      HuaKe: {
        title: "💫 Achievement in Happiness Palace",
        description: "You begin to develop interest in meditation, awareness, spiritual growth, and these 'interests' will be your future treasury. The thoughts that emerge in certain quiet moments will be seeds that illuminate a new stage of life.",
        quote: "You haven't slowed down, your soul is preparing to go deeper."
      },
      HuaJi: {
        title: "🌀 Obstacle in Happiness Palace",
        description: "In these years, you're prone to feeling 'empty, tired, unsolvable anxiety'. But this isn't illness, it's your destiny chart telling you: 'You should let go of attachments that aren't yours.'",
        quote: "You don't need to become more hardworking, you just need to be more settled."
      }
    },
    父母: {
      name: "Parents Palace",
      keyword: "👴 Parents Palace (Parents' Status/Root System/Spiritual Support)",
      meaning: "Relationship with original family, elders, spiritual support",
      HuaLu: {
        title: "☀️ Prosperity in Parents Palace",
        description: "You begin to feel support and blessings from your origins, whether they are by your side or not. Your root system begins to stabilize, and family fortune is supporting your career line.",
        quote: "Your bloodline is not just inheritance, it's a source of power."
      },
      HuaQuan: {
        title: "⚡ Power in Parents Palace",
        description: "You'll want to guide or change family structure, family rules, even parents. It's not rebellion, it's that you begin to have the ability to 'reset the rules of family energy'.",
        quote: "You're not deviating from family, you're the one creating a new pattern for them."
      },
      HuaKe: {
        title: "💫 Achievement in Parents Palace",
        description: "Spiritual dialogues between you and your parents/elders will increase, perhaps wisdom inheritance, or perhaps seeing the lessons. These exchanges will make you more complete.",
        quote: "You're not just their child, you're their evolved version."
      },
      HuaJi: {
        title: "🌀 Obstacle in Parents Palace",
        description: "You may encounter communication breakdowns, controlling oppression, emotional alienation with family. This relationship isn't here to destroy you, it's for you to 'see that you don't need to please them anymore'.",
        quote: "You weren't born to repay debts, but to transform family destiny."
      }
    },
    
    // Component UI text
    noTransformations: "No transformations found in the chart data."
  }
};

export default fourKeyPalace;
